module.exports = __webpack_public_path__ + "static/img/head.62c7bf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home/head.png
// module id = 1xVv
// module chunks = 12